import { render } from "./CelebrationAnimation.vue?vue&type=template&id=23bd7294&scoped=true"
import script from "./CelebrationAnimation.vue?vue&type=script&lang=js"
export * from "./CelebrationAnimation.vue?vue&type=script&lang=js"

import "./CelebrationAnimation.vue?vue&type=style&index=0&id=23bd7294&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd7294"]])

export default __exports__